import { useQuery } from '@tanstack/react-query';

import type { SocialProvider } from '@nucleus-commerce/api-client/admin';

import { socialApi } from '../api/social-api';

import { socialKeys } from './social-keys';

/** Live from the network; fetched only while the picker is open and the ads scopes are granted. */
export function useAdAccounts(storeId: string, provider: SocialProvider, enabled: boolean) {
  return useQuery({
    queryKey: socialKeys.adAccounts(storeId, provider),
    queryFn: () => socialApi.adAccounts(storeId, provider),
    enabled,
  });
}
